import React, { forwardRef, useEffect, useRef, useId } from 'react';
import classNames from "classnames";
import styled from "styled-components";
import IBuildrProps from '../../../utilities/IBuildrProps';
import checked from "./checked.svg";
import unchecked from "./unchecked.svg";
import uncheckedWhite from "./uncheckedWhite.svg";

export interface IInputRadioProps extends IBuildrProps {
    inputLabel: string;
    inputValue?: string;
    inputChecked: boolean;
    inputClassName: string;
    groupName: string;
    groupRequired: boolean;
    isWhite: boolean;
    checkedOptions?: Record<string, boolean>;
    onChange?: (string, boolean) => void;
}

const RadioContainer = styled.label<{ isWhite: boolean }>`

    [type="radio"] {
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
    }

    [type="radio"]:checked+.checkmark {
        background: url(${checked}) no-repeat;
    }

    &:hover .checkmark {
        transform: scale(1.05);
    }
    &.form-check {
        cursor: pointer;
    }
    .checkmark {
        position: absolute;
        left: 0;
        top: 0;
        background: url(${props => (!!props.isWhite) ? uncheckedWhite : unchecked}) no-repeat;
        height: 24px;
        width: 24px;
        cursor: pointer;
    }

    .form-check-label {
        font-size: 0.889rem;
        font-weight: 400;
        word-break: break-word;
        margin-left: 13px;
        cursor: pointer;
    }

    .form-check-input {
        margin-left: 0.3rem;
    }
`;

export default forwardRef(function InputRadio({ inputLabel, inputChecked, checkedOptions = {}, onChange = () => null, inputClassName, inputValue, groupName, groupRequired, isWhite, cmsId, editorClassObj }: IInputRadioProps, ref: any) {
    const inputId = useId();
    const selectedValue = checkedOptions[groupName] || '';
    const value = inputValue || inputLabel;

    useEffect(() => {
        if (inputChecked) {
            onChange(groupName, value);
        }
    }, [inputChecked]);

    const checkHandler = () => {
        onChange(groupName, value);
    }

    return (
        <div className={classNames(inputClassName)}>
            <RadioContainer htmlFor={inputId} className={classNames("form-group form-check pr-2", editorClassObj)} data-id={cmsId} ref={ref} isWhite={isWhite}>
                <input id={inputId} type="radio" name={groupName} onClick={checkHandler} className={classNames("form-check-input")} checked={selectedValue === value || groupName === value}
                    required={groupRequired} value={value} />
                <div className="checkmark"></div>
                <span className="form-check-label">{inputLabel}</span>
            </RadioContainer>
        </div>
    );
});
